import { X } from "lucide-react";
import { useState } from "react";
import FilterCard from "../../shared/FilterCard";
import Calendar from "react-calendar";

const TransactionFilter = ({
  closeFilters,
  handleApplyFilter,
  status,
  setStatus,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  type,
  setType,
  method,
  setMethod,
  minAmount,
  setMinAmount,
  maxAmount,
  setMaxAmount,
}) => {
  const [activeTab, setActiveTab] = useState("Status");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleStatusSelect = (label) => {
    setStatus(label.toLowerCase());
  };

  const appliedFiltersCount = [status, type, method, fromDate, toDate].filter(
    Boolean,
  ).length;

  return (
    <div
      onClick={(e) => {
        closeFilters();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[800px] h-[580px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeFilters}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[10px] right-[20px] flex items-center gap-[10px]">
          <button
            onClick={() => {
              setStatus("");
              setType("");
              setMethod("");
              setFromDate(null);
              setToDate(null);
              setMinAmount("");
              setMaxAmount("");
            }}
            className="h-[35px] bg-[#FFFFFF] border border-[#000000] rounded-[30px] px-[15px] text-[15px] font-bold text-[#000000]"
          >
            Clear Filters
          </button>
          <button
            onClick={handleApplyFilter}
            className="h-[35px] bg-[#000000] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            Apply Filters
          </button>
        </div>
        <div className="w-full">
          <p className="text-[#000000] text-[20px] font-medium">Filters</p>
          <p className="w-[90%] text-[#5C5C5C] text-[14px] font-normal">
            Refine your view by selecting specific criteria. Apply filters to
            quickly find the loan transactions you need. You can reset or adjust
            filters anytime.
          </p>
          <div className="h-[435px] w-full flex">
            <div className="w-[30%] p-[10px] bg-[#F8F8F8] h-full overflow-y-auto">
              <div className="flex items-center justify-between">
                <p className="text-[#000000] text-[14px] font-medium">
                  Filters
                </p>
                <span className="bg-[#FFDEDE] text-[#000000] text-[12px] font-normal h-[30px] rounded-[30px] px-[10px] flex items-center justify-center">
                  {appliedFiltersCount} applied
                </span>
              </div>
              <div className="flex flex-col my-[20px] gap-[20px]">
                <FilterCard
                  label="Status"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />

                <FilterCard
                  label="Transaction Type"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="Transaction Method"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="From Date"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="To Date"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="Minimum Amount"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="Maximum Amount"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
              </div>
            </div>

            <div className="w-[70%] p-[10px] bg-[#FBF5F5] h-full">
              <p className="text-[#000000] text-[14px] font-medium">
                {activeTab}
              </p>
              <p className="text-[#222222] text-[14px] font-normal">
                Select your {activeTab?.toLowerCase()} filter
              </p>
              {activeTab === "Status" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] overflow-y-auto rounded-[5px] h-[360px]">
                  {[
                    "Successful",
                    "Pending",
                    "Rejected",
                    "Failed",
                    "Reversed",
                  ].map((label) => (
                    <div
                      key={label}
                      className="flex mb-[20px] items-center justify-between"
                    >
                      <p className="text-[#000000] text-[14px] font-normal">
                        {label}
                      </p>
                      <input
                        type="radio"
                        name="status"
                        checked={status === label.toLowerCase()}
                        onChange={() => handleStatusSelect(label)}
                      />
                    </div>
                  ))}
                </div>
              )}

              {activeTab === "Transaction Type" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] rounded-[5px] h-[360px]">
                  {["Credit", "Debit", "Disbursement", "Fee"].map((label) => (
                    <div
                      key={label}
                      className="flex mb-[20px] items-center justify-between"
                    >
                      <p className="text-[#000000] text-[14px] font-normal">
                        {label}
                      </p>
                      <input
                        type="radio"
                        name="transactionType"
                        checked={type === label.toLowerCase()}
                        onChange={() => setType(label.toLowerCase())}
                      />
                    </div>
                  ))}
                </div>
              )}
              {activeTab === "Transaction Method" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] rounded-[5px] h-[360px]">
                  {["Mpesa", "Bank"].map((label) => (
                    <div
                      key={label}
                      className="flex mb-[20px] items-center justify-between"
                    >
                      <p className="text-[#000000] text-[14px] font-normal">
                        {label}
                      </p>
                      <input
                        type="radio"
                        name="transactionMethod"
                        checked={method === label.toLowerCase()}
                        onChange={() => setMethod(label.toLowerCase())}
                      />
                    </div>
                  ))}
                </div>
              )}

              {activeTab === "From Date" && (
                <div className="w-full flex items-start justify-center mt-[10px] p-[10px] h-full overflow-y-auto">
                  <Calendar
                    onChange={(val) => setFromDate(val)}
                    value={fromDate ? new Date(fromDate) : null}
                    maxDate={toDate ? new Date(toDate) : new Date()}
                  />
                </div>
              )}
              {activeTab === "To Date" && (
                <div className="w-full flex items-start justify-center mt-[10px] p-[10px] h-full overflow-y-auto">
                  <Calendar
                    onChange={(val) => setToDate(val)}
                    value={toDate ? new Date(toDate) : null}
                    minDate={fromDate ? new Date(fromDate) : null}
                    maxDate={new Date()}
                  />
                </div>
              )}
              {activeTab === "Minimum Amount" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] rounded-[5px] h-[360px]">
                  {[
                    "10000",
                    "25000",
                    "50000",
                    "100000",
                    "250000",
                    "250001",
                  ].map((amount) => (
                    <div
                      key={amount}
                      className="flex mb-[20px] items-center justify-between"
                    >
                      <p className="text-[#000000] text-[14px] font-normal">
                        {amount === "250001"
                          ? "Above KES 250,000"
                          : `KES ${parseInt(amount).toLocaleString()}`}
                      </p>
                      <input
                        type="radio"
                        name="minAmount"
                        value={amount}
                        checked={minAmount === amount}
                        onChange={(e) => setMinAmount(e.target.value)}
                      />
                    </div>
                  ))}
                </div>
              )}

              {activeTab === "Maximum Amount" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] rounded-[5px] h-[360px]">
                  {[
                    "10000",
                    "25000",
                    "50000",
                    "100000",
                    "250000",
                    "250001",
                  ].map((amount) => (
                    <div
                      key={amount}
                      className="flex mb-[20px] items-center justify-between"
                    >
                      <p className="text-[#000000] text-[14px] font-normal">
                        {amount === "250001"
                          ? "Above KES 250,000"
                          : `KES ${parseInt(amount).toLocaleString()}`}
                      </p>
                      <input
                        type="radio"
                        name="maxAmount"
                        value={amount}
                        checked={maxAmount === amount}
                        onChange={(e) => setMaxAmount(e.target.value)}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionFilter;
